<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  @if (type === 'Add' && page === 'training') {
    <div i18n="@@addTrainingMaterial">Add Training Material</div>
  }
  @if (type !== 'Add' && page === 'training') {
    <div i18n="@@editTrainingMaterial">Edit Training Material</div>
  }
  @if (type === 'Add' && page === 'marketing') {
    <div i18n="@@addMarketingMaterial">Add Marketing Material</div>
  }
  @if (type !== 'Add' && page === 'marketing') {
    <div i18n="@@editMarketingMaterial">Edit Marketing Material</div>
  }
  @if (type !== 'Add' && page === 'company') {
    <div i18n="@@editExternalMaterial">Edit External Material</div>
  }
  @if (type === 'Add' && page === 'company') {
    <div i18n="@@addExternalMaterial">Add External Material</div>
  }
  <mat-icon (click)="closeDialog()" class="cursor" i18n-label="@@closeDialog" aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <form [formGroup]="addMaterialForm">
    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@materialNameLabel">Material name</mat-label>
        <input data-testid="add_edit_name_input"  matInput id="name" i18n-placeholder="@@materialNamePlaceholder" placeholder="Material name" name="name" formControlName="name" required />
        <mat-error>  
          @if (!addMaterialForm.get('name').valid && addMaterialForm.get('name').touched) {
            @if (addMaterialForm.get('name').errors && addMaterialForm.get('name').errors['required'] || addMaterialForm.get('name').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@materialDescriptionLabel">Description</mat-label>
        <input data-testid="add_edit_description_input"  matInput id="description" i18n-placeholder="@@materialDescriptionPlaceholder"  placeholder="Description" name="description" formControlName="description" required />
        <mat-error>
          @if (!addMaterialForm.get('description').valid && addMaterialForm.get('description').touched) {
            @if (addMaterialForm.get('description').errors && addMaterialForm.get('description').errors['required'] || addMaterialForm.get('description').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
      <div class="d-flex align-items-base">
        @if (!fileIconOn) {
          <mat-form-field class="flex-grow" appearance="outline">
            <mat-label i18n="@@materialLinkLabel">Material link</mat-label>
            <input data-testid="add_edit_certificate_link"  matInput id="link" i18n-placeholder="@@materialLinkPlaceholder" placeholder="Material link" name="link" formControlName="link" required />
            <mat-error>
              @if (!addMaterialForm.get('link').valid && addMaterialForm.get('link').touched) {
                @if (addMaterialForm.get('link').errors && addMaterialForm.get('link').errors['required']) {
                  <span i18n="@@inValidRequiredField">This field is required</span>
                }
              }
              @if (addMaterialForm.get('link').errors && addMaterialForm.get('link').errors['pattern']) {
                <span i18n="@@inValidLink">Please add correct link!</span>
              }
            </mat-error>
          </mat-form-field>
        }
        @if (fileIconOn) {
          <mat-form-field (click)="imgFileInput.click();" class="flex-grow" appearance="outline">
            <mat-label i18n="@@materialFileLabel">Material file *</mat-label>
            <input data-testid="add_edit_certificate_file"  matInput id="file" i18n-placeholder="@@materialFilePlaceholder" placeholder="Material file" name="file" formControlName="file" required />
            <mat-error>
              @if (!addMaterialForm.get('file').valid && addMaterialForm.get('file').touched) {
                @if (addMaterialForm.get('file').errors && addMaterialForm.get('file').errors['required']) {
                  <span i18n="@@inValidRequiredField">This field is required</span>
                }
              }
            </mat-error>
          </mat-form-field>
        }
        <mat-icon class="{{!fileIconOn ? 'cursor off-icon-color ' : 'cursor on-icon-color'}}" (click)="imgFileInput.click();toggleIcon('file')" i18n-label="@@insertFile" aria-label="Insert File">insert_drive_file</mat-icon>
        <mat-icon class="{{fileIconOn ? 'cursor off-icon-color insert-link-icon' : 'cursor on-icon-color insert-link-icon'}}" (click)="toggleIcon('link')" i18n-label="@@insertLink" aria-label="Insert Link">insert_link</mat-icon>
        <input accept=".png, .jpg, .jpeg, .txt, .html, .pdf, .rtf, .doc, .docx, .ppt, .pptx, .xls, .xlsx" hidden type="file" onclick="this.value = null" #imgFileInput (change)="previewImage($event.target.files)"/>
      </div>
      @if (invalidFiles) {
        <div i18n="@@invalidFilesMessage" class="error">Please enter files to proceed!</div>
      }
    </div>
    <div>
      @if (type === 'Add' && page !== 'company') {
        <button i18n="@@add" data-testid="add_certificate_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Add</button>
      }
      @if (type !== 'Add' && page !== 'company') {
        <button i18n="@@save" data-testid="dit_certificate_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Save</button>
      }
      @if (type === 'Add' && page === 'company') {
        <button i18n="@@add" data-testid="add_certificate_button" class="w-100" mat-raised-button color="primary" (click)="onCompanySubmit()">Add</button>
      }
      @if (type !== 'Add' && page === 'company') {
        <button i18n="@@save" data-testid="dit_certificate_button" class="w-100" mat-raised-button color="primary" (click)="onCompanySubmit()">Save</button>
      }
    </div>
  </form>
</mat-dialog-content>